import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import dayjs from 'dayjs'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { KeyRoundIcon, PencilIcon, Trash2Icon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { ApiClient, apiClients } from 'service/api'
import {
    colunaEscopos,
    colunaStatus,
} from 'templates/Integracoes/CredenciaisApi/atoms/colunas'

export default function CredenciaisApi() {
    const { data, isLoading } = apiClients.useFetch()

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={['Integrações', 'Credenciais de API']}
                />
                <ContentGuide.DataGrid
                    onAdd
                    columns={[
                        {
                            field: 'nome',
                            headerName: 'Nome',
                            flex: 1,
                            minWidth: 150,
                        },
                        {
                            field: 'clientId',
                            headerName: 'Client ID',
                            flex: 1,
                            minWidth: 180,
                        },
                        colunaEscopos,
                        {
                            field: 'rateLimitRpm',
                            headerName: 'Limite',
                            width: 110,
                            align: 'center',
                            valueFormatter: ({ value }) =>
                                `${value || 60} req/min`,
                        },
                        colunaStatus,
                        {
                            field: 'ultimoAcessoEm',
                            headerName: 'Último acesso',
                            width: 160,
                            align: 'center',
                            renderCell: ({ value }) =>
                                value
                                    ? dayjs(value).format('DD/MM/YYYY HH:mm')
                                    : '',
                        },
                        {
                            ...optionsColumn,
                            field: '__regenerar',
                            renderCell: ({ id }) =>
                                hasPermission(
                                    ['update', 'CredenciaisDeAPI'],
                                    () => (
                                        <IconButton
                                            title="Regenerar segredo"
                                            href={`${id}/regenerar`}
                                        >
                                            <KeyRoundIcon />
                                        </IconButton>
                                    ),
                                ),
                        },
                        {
                            ...optionsColumn,
                            field: '__editar',
                            renderCell: ({ id }) =>
                                hasPermission(
                                    ['update', 'CredenciaisDeAPI'],
                                    () => (
                                        <IconButton
                                            title="Editar"
                                            href={`${id}/editar`}
                                        >
                                            <PencilIcon />
                                        </IconButton>
                                    ),
                                ),
                        },
                        {
                            ...optionsColumn,
                            field: '__excluir',
                            renderCell: ({ id }) =>
                                hasPermission(
                                    ['delete', 'CredenciaisDeAPI'],
                                    () => (
                                        <IconButton
                                            title="Excluir"
                                            href={`${id}/excluir`}
                                        >
                                            <Trash2Icon className="text-error" />
                                        </IconButton>
                                    ),
                                ),
                        },
                    ]}
                    rows={data}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-credenciais-api',
                        },
                        showQuickFilter: true,
                    }}
                    loading={isLoading}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useCredenciaisApiOutletContext() {
    return useOutletContext<{
        data?: ApiClient[]
    }>()
}
